import request from '@/utils/httpRequest'

// 联系我们-产品咨询/售后咨询
export function ApiWebConcat (params) {
  return request({
    url: request.adornUrl('/web/office/call/into'),
    method: 'post',
    data: request.adornData(params)
  })
}
// 联系我们背景图
export function ApiWebBackdropImg () {
  return request({
    url: request.adornUrl('/web/office/call/backdrop/img'),
    method: 'get',
    params: request.adornParams()
  })
}
// 联系我们背景图
export function ApiWebConcatList (params) {
  return request({
    url: request.adornUrl('/web/office/call/list'),
    method: 'post',
    data: request.adornData(params)
  })
}



// WEBPACK FOOTER //
// ./src/api/concat.js